import axios from 'axios';

// Direct connection to n8n webhook
// CORS must be enabled on n8n server or use a reverse proxy in production
const API_BASE_URL = process.env.REACT_APP_MCP_BASE_URL || 'https://n8n.dikitalsolutions.com/webhook';
const API_TOKEN = process.env.REACT_APP_MCP_TOKEN;

const client = axios.create({
  baseURL: API_BASE_URL,
  timeout: 300000, // 5 minutes timeout for long-running LLM requests
  headers: {
    'Content-Type': 'application/json',
    ...(API_TOKEN ? { Authorization: `Bearer ${API_TOKEN}` } : {}),
  },
});

// Generic response type since n8n returns the workflow output directly
type WorkflowResponse = {
  success?: boolean;
  contentType?: string;
  agentGenerated?: boolean;
  document?: unknown;
  material?: unknown;
  data?: unknown;
  template?: unknown;
  generatedAt?: string;
  content?: string;
  text?: string;
  response?: string;
  [key: string]: unknown;
};

export const executeWorkflow = async (workflowId: string, data: unknown): Promise<WorkflowResponse> => {
  console.log('[API] Executing workflow:', workflowId, data);
  const response = await client.post<WorkflowResponse>(`/${workflowId}`, data);
  console.log('[API] Workflow response:', response.data);
  return response.data;
};
